import React from "react";

import { Image, StyleSheet } from "@react-pdf/renderer";

import { siLogoBase64 } from "../../assets/icon/siLogo";

const AppendixHeaderStyle = StyleSheet.create({
	image: {
		position: "absolute",
		width: "15%",
		left: 610,
		top: 47,
	},
});

export const AppendixHeader = (): JSX.Element => {
	return (
		<Image
			style={AppendixHeaderStyle.image}
			// Due to unknown reason, Science Island logo cannot be recognized by <Image /> component
			// we have to convert image to base64 string, and it will be rendered
			src={`data:image/png;base64, ${siLogoBase64}`}
		/>
	);
};
